import { render, staticRenderFns } from "./ProgramDetailColumn.vue?vue&type=template&id=761fa538&scoped=true"
import script from "./ProgramDetailColumn.vue?vue&type=script&lang=js"
export * from "./ProgramDetailColumn.vue?vue&type=script&lang=js"
import style0 from "./ProgramDetailColumn.vue?vue&type=style&index=0&id=761fa538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fa538",
  null
  
)

export default component.exports